import {
	Component,
	Inject,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators,
	ReactiveFormsModule,
} from '@angular/forms';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { NgFor, NgIf } from '@angular/common';
import {
	MatFormField,
	MatInput,
	MatHint,
	MatError,
} from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatDivider } from '@angular/material/list';

export type VoidReason = 'declined' | 'update' | 'other';

// export interface VoidEnvelopeResult {
//   reason: VoidReason;
//   otherText?: string;
// }

@Component({
	selector: 'app-agreements-void',
	templateUrl: './agreements-void.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./agreements-void.component.scss'],
	imports: [
		MatDialogTitle,
		MatIconButton,
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		ReactiveFormsModule,
		MatRadioGroup,
		NgFor,
		MatRadioButton,
		MatFormField,
		MatInput,
		CdkTextareaAutosize,
		MatHint,
		NgIf,
		MatError,
		MatDivider,
		MatDialogActions,
		MatButton,
	],
})
export class AgreementsVoidComponent {
	voidForm!: FormGroup;

	readonly reasons: { value: VoidReason; label: string }[] = [
		{ value: 'declined', label: 'One or more parties declined the terms' },
		{ value: 'update', label: 'The agreement needs to be updated and resent' },
		{ value: 'other', label: 'Input other reason' },
	];

	readonly MAX_LENGTH = 200;

	constructor(
		private fb: FormBuilder,
		private dialogRef: MatDialogRef<AgreementsVoidComponent>,
		@Inject(MAT_DIALOG_DATA) public data
	) {}

	ngOnInit(): void {
		this.voidForm = this.fb.group({
			reason: ['other', Validators.required],
			otherText: [''],
		});

		// Dynamically require otherText only when 'other' is selected
		this.voidForm.get('reason')!.valueChanges.subscribe((val: VoidReason) => {
			const ctrl = this.voidForm.get('otherText')!;
			if (val === 'other') {
				ctrl.setValidators([
					Validators.required,
					Validators.maxLength(this.MAX_LENGTH),
				]);
			} else {
				ctrl.clearValidators();
			}
			ctrl.updateValueAndValidity();
		});

		// Trigger once to set initial validators
		this.voidForm.get('reason')!.updateValueAndValidity({ emitEvent: true });
	}

	get isOther(): boolean {
		return this.voidForm.get('reason')?.value === 'other';
	}

	get otherLength(): number {
		return (this.voidForm.get('otherText')?.value ?? '').length;
	}

	get canSubmit(): boolean {
		return this.voidForm.valid;
	}

	onVoid(): void {
		if (!this.canSubmit) return;
		const { reason, otherText } = this.voidForm.value;
		// const result: VoidEnvelopeResult = { reason };
		// if (reason === 'other') result.reason = otherText;
		// console.log(this.reasons,"+++++++++++++++++")
		// console.log(reason,result,"+++++++++++")
		let result = this.reasons.find((item) => item.value === reason)?.label;
		if (reason === 'other') result = otherText;
		console.log(result);
		this.dialogRef.close({ envelopeId: this.data?.envelopeId, reason: result });
	}

	onClose(): void {
		this.dialogRef.close(null);
	}
}
